export {default as FirstWeekTasks} from './FirstWeekTasks.connect';
